import { useState } from "react";
import { Plus, Play, Zap, Loader2, CheckCircle2, ArrowRight } from "lucide-react";
import { API } from "./constants";

export const ProjectPipelines = ({ orchestrations, runningPipeline, pipelineProgress, onRunPipeline, onOpenBuilder }) => (
  <div className="p-6 space-y-4" data-testid="pipelines-tab">
    <div className="flex items-center justify-between mb-2">
      <div>
        <h3 className="text-sm font-bold text-foreground">Agent Pipelines</h3>
        <p className="text-[11px] text-foreground/50 mt-0.5">Run AI agent pipelines against this project's content</p>
      </div>
      <button onClick={onOpenBuilder} className="text-xs font-semibold px-3 py-1.5 rounded-lg bg-[#014d7d] text-white flex items-center gap-1.5" data-testid="create-pipeline-btn">
        <Plus className="w-3 h-3" /> New Pipeline
      </button>
    </div>
    {orchestrations.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No pipelines created yet. Create one with the Agent Builder.</p>}
    {orchestrations?.map(orch => (
      <div key={orch.id} className="bg-white border border-border/50 rounded-xl p-4" data-testid={`pipeline-card-${orch.id}`}>
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-3">
            <div className={`w-9 h-9 rounded-xl bg-gradient-to-br ${orch.color || "from-[#014d7d] to-[#178a55]"} flex items-center justify-center`}>
              <Zap className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="text-sm font-bold text-foreground">{orch.name}</p>
              <p className="text-[10px] text-foreground/50">{orch.description || `${(orch.agents || []).length} agents`}</p>
            </div>
          </div>
          <button onClick={() => onRunPipeline(orch.id)} disabled={runningPipeline === orch.id}
            className={`text-xs font-semibold px-4 py-2 rounded-lg flex items-center gap-1.5 ${runningPipeline === orch.id ? "bg-amber-50 text-amber-700" : "bg-[#014d7d] text-white hover:bg-[#013d66]"}`}
            data-testid={`run-pipeline-${orch.id}`}>
            {runningPipeline === orch.id ? <><Loader2 className="w-3 h-3 animate-spin" /> Running...</> : <><Play className="w-3 h-3" /> Run</>}
          </button>
        </div>
        <div className="flex items-center gap-1.5 flex-wrap mt-2">
          {(orch.agents || [])?.map((agent, i) => (
            <div key={i} className="flex items-center gap-1">
              <span className="text-[10px] font-semibold px-2.5 py-1 rounded-lg bg-foreground/[0.04] text-foreground/50">{agent}</span>
              {i < (orch.agents || []).length - 1 && <ArrowRight className="w-2.5 h-2.5 text-foreground/15" />}
            </div>
          ))}
        </div>
        {runningPipeline === orch.id && (
          <div className="mt-3 space-y-1.5">
            {(orch.agents || [])?.map((agent, i) => (
              <div key={i} className="flex items-center gap-2">
                <span className="text-[10px] font-medium text-foreground/40 w-28 truncate">{agent}</span>
                <div className="flex-1 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                  <div className="h-full rounded-full bg-gradient-to-r from-[#014d7d] to-[#178a55] transition-all duration-300" style={{ width: `${pipelineProgress[i] || 0}%` }} />
                </div>
                {pipelineProgress[`${i}_done`] && <CheckCircle2 className="w-3 h-3 text-emerald-500" />}
              </div>
            ))}
          </div>
        )}
      </div>
    ))}
  </div>
);
